import { Box, Typography } from "@material-ui/core";
import React, { Fragment } from "react";
import { ColorsEnum } from "../enums/ColorsEnum";

interface Props {
  error?: string;
}

const ErrorText: React.FC<Props> = ({ error }) => {
  if (error)
    return (
      <Box marginTop="8px" color={ColorsEnum.ValidationRed}>
        <ul>
          {error.split("\n").map((e, i) => (
            <li key={`error-${i}`}>
              <Typography>{e}</Typography>
            </li>
          ))}
        </ul>
      </Box>
    );

  return <Fragment></Fragment>;
};

export default ErrorText;
